import React, { useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { Store } from '../Store';
import { ReactComponent as Linked } from '../assets/icons/link.svg';

export default function ConnectedClient(props) {
  const { userInfo } = props;
  const navigate = useNavigate();

  const { dispatch: ctxDispatch } = useContext(Store);

  const disconnectClientHandler = () => {
    navigate('/category/order');
    ctxDispatch({
      type: 'HELPDESK_DISCONNECT_CLIENT',
    });
  };

  return (
    <div className="connectedClient">
      <div
        style={{
          display: 'flex',
          flexDirection: 'row',
          alignItems: 'flex-start',
        }}
      >
        <div>
          <i className="fas fa-user me-2" />
        </div>
        <div>
          <div>
            <span>{userInfo.client.name}</span>
            <button
              className="linkbutton ms-2"
              onClick={() => disconnectClientHandler()}
            >
              <Linked width="22" height="22" fill="#dd7777" />
            </button>
          </div>
          <div className="text-muted" style={{ fontSize: '14px' }}>
            {userInfo.client.businessName}
          </div>
          <div className="text-muted" style={{ fontSize: '10px' }}>
            İle bağlantı kuruldu
          </div>
        </div>
      </div>
    </div>
  );
}
